module.exports = __webpack_public_path__ + "img/tool2.2d19fff7.png";